export class CardPaymentRequest {
  orderToken: string = "";
  token: string = "";
  idempotencyKey: string = "";
  PayNow: boolean = true;
}
